<template>
  <r-panel
    title="PDF Renk Ayarları"
    v-if="showPanel"
    v-model:isactive="showPanel"
    pos="center"
    width="90%"
    classes="r-flx-dw-80"
  >
    <r-flex direction="column" class="r-p-24">
      <!-- Yeni Ekle Butonu -->
      <r-flex justify="flex-end" class="r-mb-16">
        <r-btn bgcolor="#28a745" @click="openAddModal">
          Yeni Renk Ekle
        </r-btn>
      </r-flex>

      <!-- Renk Listesi -->
      <r-data-list
        :headdata="headdata"
        :listdata="colorList"
        :opt="opts"
        v-if="loaded"
        :searchfilter="searchfilter"
        v-model:qu="q"
      >
        <template v-slot:col1="{ datarow }">
          {{ datarow.id }}
        </template>
        <template v-slot:col2="{ datarow }">
          {{ datarow.colorKey }}
        </template>
        <template v-slot:col3="{ datarow }">
          {{ datarow.colorValue }}
        </template>
        <template v-slot:col4="{ datarow }">
          <!-- Renk Önizleme -->
          <div
            class="color-preview"
            :style="{ backgroundColor: datarow.colorValue }"
            :title="datarow.colorValue"
          ></div>
        </template>
        <template v-slot:col5="{ datarow }">
          {{ datarow.description || "-" }}
        </template>
        <template v-slot:col6="{ datarow }">
          <span
            class="r-check-ok small"
            v-if="datarow.isActive === true"
          ></span>
          <span class="r-check-no small" v-else></span>
        </template>
        <template v-slot:col7="{ datarow }">
          <r-btn
            bgcolor="#007bff"
            @click="openEditModal(datarow)"
            class="r-mr-8"
          >
            Düzenle
          </r-btn>
        </template>
      </r-data-list>

      <div v-if="!loaded" class="r-p-24" style="text-align: center;">
        Yükleniyor...
      </div>
    </r-flex>
  </r-panel>

  <!-- Ekleme/Düzenleme Modal -->
  <r-panel
    :title="editMode ? 'Renk Düzenle' : 'Yeni Renk Ekle'"
    v-if="showEditModal"
    v-model:isactive="showEditModal"
    pos="center"
    width="500px"
    classes="r-flx-dw-80"
  >
    <r-flex direction="column" class="r-p-24">
      <r-input
        v-model="editData.colorKey"
        label="Renk Anahtarı"
        :disabled="editMode"
        class="r-mb-16"
      />
      <r-input
        v-model="editData.colorValue"
        label="Renk Değeri"
        placeholder="örn: red, #cccff1, blue"
        class="r-mb-16"
      />
      <r-input
        v-model="editData.description"
        label="Açıklama"
        class="r-mb-16"
      />
      <r-checkbox
        v-model="editData.isActive"
        label="Aktif mi?"
        class="r-mb-16"
      />

      <!-- Renk Önizleme -->
      <div class="r-mb-16">
        <label style="font-weight: 500; margin-bottom: 8px; display: block;">
          Renk Önizleme:
        </label>
        <div
          class="color-preview-large"
          :style="{ backgroundColor: editData.colorValue || '#ffffff' }"
        ></div>
        <div style="margin-top: 8px; font-size: 12px; color: #666;">
          {{ editData.colorValue || "Renk değeri girin" }}
        </div>
      </div>

      <r-flex justify="flex-end" gap="12px">
        <r-btn bgcolor="#6c757d" @click="closeEditModal">
          İptal
        </r-btn>
        <r-btn bgcolor="#28a745" @click="saveColor" :disabled="saving">
          <span v-if="saving">Kaydediliyor...</span>
          <span v-else>{{ editMode ? "Güncelle" : "Kaydet" }}</span>
        </r-btn>
      </r-flex>
    </r-flex>
  </r-panel>
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { reloadPdfColors } from "@/utils/pdfColors.js";

export default {
  setup() {
    const store = useStore();
    const showPanel = ref(true);
    const loaded = ref(false);
    const colorList = ref([]);
    const q = ref("");
    const showEditModal = ref(false);
    const editMode = ref(false);
    const editData = ref({
      id: null,
      colorKey: "",
      colorValue: "",
      description: "",
      isActive: true
    });
    const saving = ref(false);

    const headdata = [
      { name: "Id", val: "id", width: "5%" },
      { name: "Renk Anahtarı", val: "colorKey", width: "20%" },
      { name: "Renk Değeri", val: "colorValue", width: "15%" },
      { name: "Önizleme", val: "preview", width: "10%" },
      { name: "Açıklama", val: "description", width: "30%" },
      { name: "Aktif", val: "isActive", width: "10%" },
      { name: "İşlemler", val: "actions", width: "10%" }
    ];

    const opts = {
      pageSize: 20,
      pageSizes: [10, 20, 50, 100]
    };

    const searchfilter = v => {
      if (!q.value) return true;
      const search = q.value.toLowerCase();
      return (
        (v.colorKey && v.colorKey.toLowerCase().includes(search)) ||
        (v.colorValue && v.colorValue.toLowerCase().includes(search)) ||
        (v.description && v.description.toLowerCase().includes(search))
      );
    };

    const loadColors = async () => {
      try {
        loaded.value = false;
        const result = await store.dispatch("getDatas", {
          api: "References/GetAllPdfColors"
        });

        if (result && result.result === true && result.data) {
          colorList.value = result.data;
          loaded.value = true;
        } else {
          console.error("Renkler yüklenemedi:", result);
          loaded.value = true;
        }
      } catch (error) {
        console.error("Renkler yüklenirken hata:", error);
        loaded.value = true;
      }
    };

    const openAddModal = () => {
      editMode.value = false;
      editData.value = {
        id: null,
        colorKey: "",
        colorValue: "",
        description: "",
        isActive: true
      };
      showEditModal.value = true;
    };

    const openEditModal = color => {
      editMode.value = true;
      editData.value = {
        id: color.id,
        colorKey: color.colorKey,
        colorValue: color.colorValue,
        description: color.description || "",
        isActive: color.isActive
      };
      showEditModal.value = true;
    };

    const closeEditModal = () => {
      showEditModal.value = false;
      editData.value = {
        id: null,
        colorKey: "",
        colorValue: "",
        description: "",
        isActive: true
      };
    };

    const saveColor = async () => {
      if (!editData.value.colorKey || !editData.value.colorValue) {
        alert("Renk anahtarı ve değeri boş olamaz!");
        return;
      }

      saving.value = true;
      try {
        let result;
        if (editMode.value) {
          // Güncelle
          const updateUrl = `References/UpdatePdfColor?id=${
            editData.value.id
          }&colorValue=${encodeURIComponent(
            editData.value.colorValue
          )}&description=${encodeURIComponent(
            editData.value.description || ""
          )}&isActive=${editData.value.isActive}`;
          result = await store.dispatch("postDatas", {
            api: updateUrl,
            data: {}
          });
        } else {
          // Yeni Ekle
          const addUrl = `References/AddPdfColor?colorKey=${encodeURIComponent(
            editData.value.colorKey
          )}&colorValue=${encodeURIComponent(
            editData.value.colorValue
          )}&description=${encodeURIComponent(
            editData.value.description || ""
          )}`;
          result = await store.dispatch("postDatas", {
            api: addUrl,
            data: {}
          });
        }

        if (result && result.result === true) {
          alert(
            editMode.value
              ? "Renk başarıyla güncellendi!"
              : "Renk başarıyla eklendi!"
          );
          closeEditModal();
          await loadColors();
          // Frontend cache'i temizle
          await reloadPdfColors();
        } else {
          alert("İşlem başarısız: " + (result?.message || "Bilinmeyen hata"));
        }
      } catch (error) {
        console.error("Renk kaydedilirken hata:", error);
        alert("Renk kaydedilirken bir hata oluştu: " + error.message);
      } finally {
        saving.value = false;
      }
    };

    onMounted(async () => {
      await loadColors();
    });

    return {
      showPanel,
      loaded,
      colorList,
      q,
      headdata,
      opts,
      searchfilter,
      showEditModal,
      editMode,
      editData,
      saving,
      openAddModal,
      openEditModal,
      closeEditModal,
      saveColor
    };
  }
};
</script>

<style scoped>
.color-preview {
  width: 40px;
  height: 40px;
  border: 2px solid #ddd;
  border-radius: 4px;
  display: inline-block;
  cursor: pointer;
}

.color-preview-large {
  width: 100%;
  height: 80px;
  border: 2px solid #ddd;
  border-radius: 4px;
  display: block;
}
</style>
